import {
  ComponentPropsWithoutRef,
  ElementType,
  ReactNode,
  useState,
} from "react";
import { Box } from "@mui/material";
import { CSS } from "@dnd-kit/utilities";
import { useSortable } from "@dnd-kit/sortable";

type Props<T extends ElementType> = {
  id: string;
  children: ReactNode;
  as?: T;
} & Omit<ComponentPropsWithoutRef<T>, "id">;

const Draggable = <T extends ElementType = typeof Box>({
  id,
  as,
  children,
  ...rest
}: Props<T>) => {
  const { setNodeRef, attributes, listeners, transform, transition } =
    useSortable({ id });
  const [grab, setGrab] = useState<boolean>(false);

  const Component = as ?? Box;

  return (
    <Component
      ref={setNodeRef}
      {...listeners}
      {...attributes}
      {...rest}
      onMouseDown={() => setGrab(true)}
      onMouseUp={() => setGrab(false)}
      onMouseLeave={() => setGrab(false)}
      sx={{
        cursor: grab ? "grabbing" : "grab",
        transform: CSS.Transform.toString(transform),
        transition,
        ...rest.style,
      }}
    >
      {children}
    </Component>
  );
};

export default Draggable;
